<template>
    <div class="qrcode-index">
        <LiefengContent :isBack="true"  @backClick="backClick">
            <template v-slot:title>获取社区邀请码</template>
            <template v-slot:toolsbarRight></template>
            <template v-slot:contentArea>
                <div class="content">
                    <div class="left">
                        <Form :label-colon="true" :inline="true" class="search">
                            <FormItem class="info">
                                <span slot="label" class="validate">社区:</span>
                                <LiefengCascaderCity :width="250" :orgCode="4401" :resetNum="0" @changeCasader="changeCasader" ref="cascaderCity" :CascaderList="cascaderIdList"></LiefengCascaderCity>
                            </FormItem>
                            <FormItem>
                                <span slot="label" class="validate">标题:</span>
                                <Input v-model="addTitle.title" placeholder="邀请居民加入社区随约服务网上驿站" style="width: 250px"></Input>
                            </FormItem>
                            <FormItem>
                                <span slot="label" class="validate">内容:</span>
                                <iframe name="ueditor" id="ueditor" src="/mobileeditor/#/index?titlename=内容详情（必填）" style="width: 100%; height: 500px; border: 0px" @load="loadUeditor"></iframe>
                                <!-- <Input v-model="addTitle.content" :rows="10" type="textarea" placeholder="请输入内容" style="width: 250px"></Input> -->
                            </FormItem>
                        </Form>
                        <div class="btn-div" style="display: flex; justify-content: center">
                            <Button type="primary" style="margin-right: 20px;margin-top:30px" @click="loadingBtn">生成邀请码</Button>
                        </div>
                    </div>
                    <div class="right">
                        <div>
                            <h3 style="margin-top: 10px">该链接可以用于配置到公众号进行推广:</h3>
                            <div style="display: flex; justify-content: space-between; line-height: 32px; margin: 14px auto">
                                <span>公众号链接：</span>
                                <Input v-model="officialUrl" search enter-button="复制" style="flex: 1; margin-right: 100px;width:400px" @on-search="copyShareCode" :disabled="!isShow"></Input>
                            </div>
                            <h3>推广二维码已生成，可下载后直接分享二维码到微信（朋友、朋友圈）</h3>
                            <div class="qrdiv">
                                <div style="display: flex; align-items: center; justify-content: center">
                                    <div :class="!textActive ? 'qrcode qrcode-antoer' : 'qrcode'" ref="haibaoImg" :style="{ background: `url('${qrimg}') no-repeat` }">
                                        <div class="h1h3">
                                            <div
                                                :class="
                                                    qrOCdeName.length <= 8
                                                        ? !textActive
                                                            ? 'fontsize1 fontactive'
                                                            : 'fontsize1'
                                                        : qrOCdeName.length > 8 && qrOCdeName.length <= 30
                                                        ? !textActive
                                                            ? 'fontsize2 fontactive'
                                                            : 'fontsize2'
                                                        : !textActive
                                                        ? 'fontsize3 fontactive'
                                                        : 'fontsize3'
                                                "
                                            >
                                                {{ qrOCdeName | spliceTitle }}
                                            </div>
                                        </div>
                                        <span style="letter-spacing: 3px; z-index: 99">{{ qrCodeOrgName }}</span>
                                        <img :src="codeImgUrl + '?' + new Date().getTime()" alt ref="qrCode" crossorigin="anonymous" style="z-index: 98" />
                                    </div>
                                    <div style="margin-left: 30px">
                                        <div style="margin-bottom: 20px">
                                            <Button type="primary" style="margin-right: 20px" @click="downloadImgCode" :disabled="!isShow">下载纯二维码</Button>
                                            <Button type="warning" @click="mergeImage" :disabled="!isShow">下载宣传二维码</Button>
                                        </div>
                                        <div :class="!textActive ? 'diyimg' : 'diyimg diyimg-right'">
                                            <Progress v-if="file.showProgress" :percent="file.percentage" :stroke-width="5"></Progress>
                                            <Upload
                                                ref="imgUpload"
                                                :before-upload="beforeUpload"
                                                :format="['jpg', 'jpeg', 'png', 'gif']"
                                                style="display: inline-block"
                                                :on-format-error="imageError"
                                                :on-progress="imageProgress"
                                                :on-success="(value, file) => imageSuccess(file)"
                                                :action="action"
                                                :data="uploadData"
                                                :on-remove="imageRemove"
                                                :show-upload-list="false"
                                            >
                                                <Button icon="ios-cloud-upload-outline" type="info" :disabled="!isShow">自定义更换背景</Button>
                                            </Upload>
                                            <Button v-if="qrimg" type="success" @click="cropperFn" style="margin-left: 10px" :disabled="!isShow">裁剪图片</Button>
                                            <div class="checkimg">
                                                <div class="imglist">
                                                    <img
                                                        @click="changeQrimgNo(item, index)"
                                                        :class="qrimgNo == index + 1 ? 'active' : ''"
                                                        v-for="(item, index) in qrimgList"
                                                        :key="item"
                                                        :src="item"
                                                        alt=""
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- <div
                            v-if="!codeImgUrl && !officialUrl && linkMake == false && showMake == false"
                            style="
                                height: calc(100vh - 305px);
                                overflow: auto;
                                margin: 20px;
                                border-radius: 4px;
                                position: relative;
                                display: flex;
                                justify-content: center;
                                align-items: center;
                                background: #ccc;
                                color: #fff;
                                font-size: 20px;
                            "
                        >
                            可生成街道或者社区的推广链接和二维码
                        </div> -->
                    </div>
                </div>
                <!-- 分享二维码背景图片裁剪弹窗 -->
                <LiefengModal @input="cropperCancel" width="600px" height="500px" :value="cropperStatus">
                    <template v-slot:contentarea>
                        <div class="cropper-content" v-if="cropperStatus">
                            <div class="cropper" style="text-align: center">
                                <vueCropper
                                    ref="cropper"
                                    :img="option.img"
                                    :outputSize="option.size"
                                    :outputType="option.outputType"
                                    :info="true"
                                    :full="option.full"
                                    :canMove="option.canMove"
                                    :canMoveBox="option.canMoveBox"
                                    :original="option.original"
                                    :autoCrop="option.autoCrop"
                                    :fixed="option.fixed"
                                    :fixedNumber="option.fixedNumber"
                                    :centerBox="option.centerBox"
                                    :infoTrue="option.infoTrue"
                                    :fixedBox="option.fixedBox"
                                ></vueCropper>
                            </div>
                        </div>
                    </template>
                    <template v-slot:toolsbar>
                        <Button type="info" @click="cropperCancel(false)" style="margin-right: 10px">取消</Button>
                        <Button type="primary" @click="cropperFinish">裁剪</Button>
                    </template>
                </LiefengModal>
            </template>
        </LiefengContent>
    </div>
</template>

<script>
import LiefengContent from "@/components/LiefengContent3"
import LiefengModal from "@/components/LiefengModal"
import LiefengCascaderCity from "@/components/LiefengCascaderCity"
import html2canvas from "html2canvas";
import { getCachedQrcodeBgImages } from "@/portal/portalConfig.js"
export default {
    //import引入的组件需要注入到对象中才能使用
    components: { LiefengContent, LiefengModal, LiefengCascaderCity },
    data() {
        const qrimgList = getCachedQrcodeBgImages()
        //这里存放数据
        return {
            officialUrl: "",
            textActive: false,
            qrOCdeName: "",
            qrCodeOrgName: "",
            codeImgUrl: "",
            // 上传图片
            action: "",
            file: "",
            uploadData: {},
            imageName: "",
            imagePath: "",
            // 裁剪组件的基础配置option
            option: {
                img: "", // 裁剪图片的地址
                info: true, // 裁剪框的大小信息
                outputSize: 0.8, // 裁剪生成图片的质量
                outputType: "jpg", // 裁剪生成图片的格式
                canScale: true, // 图片是否允许滚轮缩放
                autoCrop: true, // 是否默认生成截图框
                autoCropWidth: 600, // 默认生成截图框宽度
                autoCropHeight: 500, // 默认生成截图框高度
                fixedBox: false, // 固定截图框大小 不允许改变
                fixed: true, // 是否开启截图框宽高固定比例
                fixedNumber: [400, 565], // 截图框的宽高比例
                full: true, // 是否输出原图比例的截图
                canMoveBox: true, // 截图框能否拖动
                original: false, // 上传图片按照原始比例渲染
                centerBox: true, // 截图框是否被限制在图片里面
                infoTrue: false, // true 为展示真实输出图片宽高 false 展示看到的截图框宽高
            },
            cropperStatus: false,
            // 分享二维码图片列表（门户配置 qrcodeBgImages，缺省 pic_hd1~6）
            qrimgList,
            qrimgNo: "1",
            qrimg: qrimgList[0] || "/images/pic_hd1.png",

            cascaderIdList: [],

            addTitle: {
                title: "",
                content: "",
            },
            createRow: {},

            saveRow: {},
            isShow:false
        }
    },
    //方法集合
    methods: {
        backClick(){
            this.$router.push('/homepage')
        },
        loadUeditor() {
            if (this.addTitle.content != "" && this.addTitle.content != null && this.addTitle.content != undefined) {
                var v_Obj = document.getElementById("ueditor").contentWindow //获取iframe对象
                v_Obj.setContent(this.addTitle.content) //写入编辑器富文本内容
            } else {
                setTimeout(this.loadUeditor, 300)
            }
        },
        // 生成二维码
        loadingBtn() {
            var v_Obj = document.getElementById("ueditor").contentWindow //获取iframe对象
            this.addTitle.content = v_Obj.getContent() //获取富文本内容

            if (!this.cascaderIdList || this.cascaderIdList.length != 3) {
                this.$Message.warning({
                    content: "社区不能为空或只能选择到社区后进行查询",
                    background: true,
                })
                return
            }
            if (this.addTitle.title == "") {
                this.$Message.warning({
                    content: "标题不能为空",
                    background: true,
                })
                return
            }
            if (this.addTitle.content == "") {
                this.$Message.warning({
                    content: "内容不能为空",
                    background: true,
                })
                return
            }
            if (this.cascaderIdList && this.cascaderIdList.length == 3) {
                this.selectByOrgCode()
            }
        },

        // 获取单个社区详情即可偶
        async getOrgDetail(orgCode) {
            await this.$get("/gateway/org/app/organization/selectOrgIndex", {
                orgCode,
            }).then(res => {
                if (res.data) {
                    this.qrCodeOrgName = res.data.orgName
                }
            })
        },
        //    根据社区获取邀请码信息
        async selectByOrgCode() {
            this.$Message.loading({
                content: "正在获取当前社区信息",
            })
            await this.$get("/info/api/pc/communityInvite/selectByOrgCode", {
                orgCode: this.cascaderIdList[this.cascaderIdList.length - 1],
            }).then(async res => {
                this.$Message.destroy()
                this.createRow = res.data
                this.isShow = true
                if(!res || !res.data){
                     await this.saveInvite()
                     await this.createQrcode()
                     await this.saveInvite(this.saveRow.inviteId)
                }else{
                     await this.saveInvite()
                     this.qrOCdeName = this.addTitle.title
                     this.codeImgUrl = res.data.url
                     this.officialUrl = "pages/welcome/welcome?scene=" + res.data.wpCode
                }
               
            })
        },
        // 保存社区邀请码
        async saveInvite(id) {
            await this.$post(
                "/info/api/pc/communityInvite/saveInvite",
                {
                    inviteId: this.createRow && this.createRow.inviteId != '' ? this.createRow.inviteId : id || "",
                    title: this.addTitle.title,
                    content: this.addTitle.content,
                    communityCode: this.cascaderIdList[this.cascaderIdList.length - 1],
                    wpCode: this.createRow && this.createRow.wpCode != '' ? this.createRow.wpCode : this.qrRow && this.qrRow.code != '' ? this.qrRow.code : '' || '',
                    link: this.createRow && this.createRow.link != '' ? this.createRow.link : this.qrRow && this.qrRow.value != '' ? this.qrRow.value : '' || '',
                    url: this.createRow && this.createRow.url ? this.createRow.url : this.qrRow && this.qrRow.codeUrl != '' ? this.qrRow.codeUrl : '' || '',
                },
                { "content-type": "application/json" }
            ).then(res => {
                if (res && res.data && res.code == 200) {
                    this.saveRow = res.data
                } else {
                    this.$Message.error({
                        content: "二维码生成失败",
                        background: true,
                    })
                    return
                }
            })
        },
        async createQrcode() {
            this.$Message.loading({
                content: "正在生成二维码",
            })
            await this.$post(
                "/datamsg/api/pc/wxqr/createWxAppletQr",
                {
                    type: "QRCODE",
                    value: JSON.stringify({
                        path: "pages/welcome/welcome",
                        redirectPath: "apps/suiyue/pages/qrcode/index",
                        params: {
                            inviteId: this.saveRow.inviteId,
                            orgCode: this.cascaderIdList[this.cascaderIdList.length - 1],
                        },
                    }),
                },
                { "Content-Type": "application/json" }
            ).then(res => {
                this.$Message.destroy()
                if (res.code == 200 && res.data) {
                    this.qrOCdeName = this.addTitle.title
                    this.codeImgUrl = res.data.codeUrl
                    this.officialUrl = "pages/welcome/welcome?scene=" + res.data.code
                    this.qrRow = res.data
                }
            })
        },
        // 城市组件
        async changeCasader(val) {
            this.cascaderIdList = val
            if(this.cascaderIdList && this.cascaderIdList.length == 3){
               await this.getOrgDetail(this.cascaderIdList[this.cascaderIdList.length - 1])
               this.addTitle.title = `欢迎进入${this.qrCodeOrgName}随约服务小程序`
            }
        },
        //取消裁剪
        cropperCancel(status) {
            this.cropperStatus = status
        },
        // 点击复制
        copyShareCode() {
            var oInput = document.createElement("input")
            oInput.value = this.officialUrl
            document.body.appendChild(oInput)
            oInput.select()
            document.execCommand("Copy")
            oInput.className = "oInput"
            oInput.style.display = "none"
            document.body.removeChild(oInput)
            this.$Message.success({
                background: true,
                content: "复制链接成功！",
            })
        },
        // 下载纯二维码
        downloadImgCode() {
            var image = new Image()
            // 解决跨域 Canvas 污染问题
            image.setAttribute("crossOrigin", "anonymous")
            image.onload = function () {
                var canvas = document.createElement("canvas")
                canvas.width = image.width
                canvas.height = image.height
                var context = canvas.getContext("2d")
                context.drawImage(image, 0, 0, image.width, image.height)
                var url = canvas.toDataURL("image/png") //得到图片的base64编码数据
                var a = document.createElement("a") // 生成一个a元素
                var event = new MouseEvent("click") // 创建一个单击事件
                a.download = "推广二维码"
                a.href = url // 将生成的URL设置为a.href属性
                a.dispatchEvent(event) // 触发a的单击事件
            }
            image.src = this.codeImgUrl
        },
        // 点击下载宣传二维码
        mergeImage() {
            html2canvas(this.$refs.haibaoImg, { useCORS: true }).then(function (canvas) {
                let src = canvas.toDataURL()
                var image = new Image()

                // 解决跨域 Canvas 污染问题
                image.setAttribute("crossOrigin", "anonymous")
                image.onload = function () {
                    canvas.width = image.width
                    canvas.height = image.height
                    var context = canvas.getContext("2d")
                    context.drawImage(image, 0, 0, image.width, image.height)
                    var url = canvas.toDataURL("image/png", 1.0)
                    var a = document.createElement("a")
                    var event = new MouseEvent("click")
                    a.download = "宣传二维码"
                    a.href = url
                    a.dispatchEvent(event)
                }
                image.src = src
            })
        },
        // 上传之前
        beforeUpload(file) {
            return this.$get("/datamsg/api/common/file/getWebPolicy?bucketName=liefeng").then(res => {
                if (res.code == 200) {
                    let now = this.$core.randomNumber()
                    //防止文件名有.
                    let suffixArr = file.name.split(".")
                    let suffix = "." + suffixArr[suffixArr.length - 1]
                    this.action = window.vue.getProxy()["/oss"].target
                    this.uploadData = {
                        name: now + suffix,
                        host: res.data.host,
                        key: res.data.key + now + suffix,
                        policy: res.data.encodedPolicy,
                        OSSAccessKeyId: res.data.accessId,
                        success_action_status: "200",
                        signature: res.data.postSignature,
                    }
                    this.imageName = now + suffix
                    this.imagePath = res.data.host + res.data.key + this.imageName
                }
            })
        },
        //图片上传成功
        imageSuccess(file) {
            if (file.status == "finished") {
                this.qrimgNo = ""
                this.qrimg = this.imagePath
                this.$Message["success"]({
                    background: true,
                    content: "图片上传成功！",
                })
            } else {
                this.$Message["error"]({
                    background: true,
                    content: "图片上传失败！",
                })
            }
        },
        // 图片格式错误
        imageError(file) {
            this.$Notice.warning({
                title: "上传文件格式错误！",
                desc: "文件 " + file.name + " 上传失败, 请上传jpg, jpeg, png或gif格式的图片！",
            })
        },
        // 图片上传进度
        imageProgress(event, file, fileList) {
            this.file = file
            event.target.onprogress = event => {
                let uploadPercent = parseFloat(((event.loaded / event.total) * 100).toFixed(2)) // 保留两位小数
                // 手动设置显示上传进度条 以及上传百分比
                this.file.showProgress = true
                this.file.percentage = uploadPercent
            }
        },
        // 图片移除
        imageRemove(file) {
            this.qrimg = ""
            this.file = {}
        },
        //打开裁剪
        async cropperFn() {
            if (!this.uploadData.host) {
                await this.$get("/datamsg/api/common/file/getWebPolicy?bucketName=liefeng").then(res => {
                    if (res.code == 200) {
                        let now = this.$core.randomNumber()
                        //防止文件名有.
                        let suffixArr = this.qrimg.split(".")
                        let suffix = "." + suffixArr[suffixArr.length - 1]
                        this.action = window.vue.getProxy()["/oss"].target
                        this.uploadData = {
                            name: now + suffix,
                            host: res.data.host,
                            key: res.data.key + now + suffix,
                            policy: res.data.encodedPolicy,
                            OSSAccessKeyId: res.data.accessId,
                            success_action_status: "200",
                            signature: res.data.postSignature,
                        }
                        this.imageName = now + suffix
                        this.imagePath = this.uploadData.host + this.uploadData.key
                    }
                })
            }
            let _this = this
            this.setAvatarBase64(this.qrimg, base64 => {
                _this.option.img = base64
            })
            this.cropperStatus = true
        },
        //确定裁剪
        cropperFinish() {
            this.$refs.cropper.getCropBlob(data => {
                this.$refs.imgUpload.clearFiles()
                let formData = new FormData()
                formData.append("name", this.uploadData.name)
                formData.append("host", this.uploadData.host)
                formData.append("key", this.uploadData.key)
                formData.append("policy", this.uploadData.policy)
                formData.append("OSSAccessKeyId", this.uploadData.OSSAccessKeyId)
                formData.append("success_action_status", this.uploadData.success_action_status)
                formData.append("signature", this.uploadData.signature)
                formData.append("file", data)
                this.$post("https://liefeng.oss-cn-shenzhen.aliyuncs.com", formData, {
                    "Content-Type": "multipart/form-data",
                }).then(res => {
                    this.$Message.success({
                        background: true,
                        content: "裁剪完成",
                    })
                    this.qrimg = ""
                    this.$nextTick(() => {
                        this.qrimg = this.imagePath + "?" + new Date().getTime()
                        this.cropperCancel(false)
                    })
                })
            })
        },
        // 设置图片base64
        setAvatarBase64(src, callback) {
            let _this = this
            let image = new Image()
            // 处理缓存
            image.src = src + "?v=" + Math.random()
            // 支持跨域图片
            image.crossOrigin = "*"
            image.onload = function () {
                let base64 = _this.transBase64FromImage(image)
                callback && callback(base64)
            }
        },
        // 将网络图片转换成base64格式
        transBase64FromImage(image) {
            let canvas = document.createElement("canvas")
            canvas.width = image.width
            canvas.height = image.height
            let ctx = canvas.getContext("2d")
            ctx.drawImage(image, 0, 0, image.width, image.height)
            // 可选其他值 image/jpeg
            return canvas.toDataURL("image/png")
        },

        // 二维码背景选择
        changeQrimgNo(item, index) {
            this.qrimgNo = index + 1
            this.qrimg = `${item}`
            if (index >= 10) {
                this.textActive = true
            } else {
                this.textActive = false
            }
        },
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
        this.addTitle.content = `<div id="editorGroup" style="position: relative; inset: 0px; max-width: 100%; padding: 10px 45px; overflow: hidden; background: url(&quot;https://liefeng.oss-cn-shenzhen.aliyuncs.com/TEST/zjsm/20230615/044417903.jpeg&quot;) 0% 0% / 100% rgba(0, 0, 0, 0); font-size: 16.1px; color: rgb(51, 51, 51);"><div type="editable" class="component" style="min-height:22px;word-wrap:break-word;"><div></div></div><div type="editable" class="component" style="min-height:22px;word-wrap:break-word;"><div></div></div><div type="editable" class="component" style="min-height:22px;word-wrap:break-word;"><div></div></div><div type="editable" class="component" style="min-height:22px;word-wrap:break-word;" draggable="false"><span style="font-weight: 700;">各位街坊：</span><div></div></div><div type="editable" class="component" style="min-height:22px;word-wrap:break-word;" draggable="false"><div style="text-indent: 2em;"><span style="font-weight: 700;">为提升社区治理和服务能力，创新基层社会治理新模式，加强与辖区居民的联系，本社区正式推广使用随约服务平台，让基层组织力在服务引领中不断增强。</span><br></div></div><div type="editable" class="component" style="min-height:22px;word-wrap:break-word;"><div></div></div><div type="editable" class="component" style="min-height:22px;word-wrap:break-word;" draggable="false"><div style="text-indent: 2em;">今后本社区相关工作和通知将会在此发布为保障居民能第一时间收到社区通知，请各位居民订阅随约小程序消息通知，谢谢!</div></div><div type="editable" class="component" style="min-height:22px;word-wrap:break-word;"><div></div></div><div type="editable" class="component" style="min-height: 22px; overflow-wrap: break-word; text-align: right;" draggable="false">社区居委会<div style="text-align: right;"></div></div><div type="editable" class="component" style="min-height:22px;word-wrap:break-word;" draggable="false"><div></div></div><div type="editable" class="component" style="min-height:22px;word-wrap:break-word;"><div></div></div><div type="editable" class="component" style="min-height:22px;word-wrap:break-word;"><div></div></div><div type="editable" class="component" style="min-height:22px;word-wrap:break-word;"><div></div></div><div type="editable" class="component" style="min-height:22px;word-wrap:break-word;" draggable="false"><div style="text-align: right;"><br></div></div><div type="editable" class="component" style="min-height:22px;word-wrap:break-word;"><div></div></div><div type="editable" class="component" style="min-height:22px;word-wrap:break-word;" draggable="false"><div></div></div><div type="editable" class="component" style="min-height:22px;word-wrap:break-word;"><div></div></div><div type="editable" class="component" style="min-height:22px;word-wrap:break-word;"><div></div></div><div type="editable" class="component" style="min-height:22px;word-wrap:break-word;"><div></div></div><div type="editable" class="component" style="min-height:22px;word-wrap:break-word;" draggable="false"><div></div></div></div>`
        sessionStorage.setItem("NODEENV", process.env.NODE_ENV)
        
        this.loadUeditor()

    },
    filters: {
        spliceTitle(option) {
            if (option.length > 22) {
                return (option = option.slice(0, 22) + "...")
            } else {
                return option
            }
        },
    },
}
</script>
<style lang='less' scoped>
.qrcode-index {
    width: 100%;
    .content {
        display: flex;
        width: 100%;
        height: 100%;
    }
    .left {
        height: 100%;
        width: 50%;
        border-right: 1px solid #ccc;
        position: relative;
    }
    .right {
        padding-left:20px;
        height: 100%;
        flex: 1;
        .qrdiv {
            position: relative;
            .qrcode {
                position: relative;
                width: 400px;
                height: 565px;
                background: url("/images/pic_hd1.jpg") no-repeat;
                background-size: 100% 100% !important;
                img {
                    position: absolute;
                    top: 242px;
                    left: 90px;
                    width: 220px;
                }

                .h1h3 {
                    width: 260px;
                    height: 119px;
                    // background-color: #333333;
                    // color: #ff0000;
                    color: #333;
                    // width: 100%;
                    position: absolute;
                    top: 75px;
                    left: 70px;
                    text-align: center;
                    h1 {
                        width: 59%;
                        margin: 0 auto;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        display: -webkit-box;
                        -webkit-line-clamp: 3;
                        -webkit-box-orient: vertical;
                    }
                }
                .fontsize1 {
                    width: 100%;
                    font-size: 26px;
                    line-height: 119px;
                    word-break: break-all;
                }
                .fontsize2 {
                    width: 100%;
                    box-sizing: border-box;
                    font-size: 24px;
                    line-height: 33px;
                    word-break: break-all;
                    position: absolute;
                    left: 50%;
                    top: 50%;
                    transform: translate(-50%, -50%);
                }
                .fontsize3 {
                    width: 100%;
                    font-size: 20px;
                    word-break: break-all;
                    line-height: 30px;
                    position: absolute;
                    left: 50%;
                    top: 50%;
                    transform: translate(-50%, -50%);
                }
                .fontactive {
                    margin-top: 50px;
                }
                h1 {
                    text-align: left;
                    font-size: 26px;
                    color: red;
                    margin-bottom: 10px;
                    line-height: 36px;
                }
                h3 {
                    padding: 0 30px;
                    text-align: center;
                    font-size: 26px;
                    color: #c62e23;
                }
                p {
                    width: 100%;
                    position: absolute;
                    top: 201px;
                    text-align: center;
                    font-size: 15px;
                    color: #666666;
                }
                span {
                    width: 70%;
                    position: absolute;
                    text-align: center;
                    top: 470px;
                    font-size: 18px;
                    color: #333;
                    margin: 0 15%;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                }
            }
            .qrcode-antoer {
                width: 334px;
                height: 544px;
                .h1h3 {
                    left: 35px;
                }
                img {
                    left: 55px;
                }
            }
        }
    }

    .diyimg {
        // position: absolute;
        // right: 162px;
        // bottom: 286px;
        // width: 380px;
        // height: 180px;
        .imglist {
            margin-top: 10px;
            display: flex;
            justify-content: flex-start;
            flex-wrap: wrap;
            width: 310px;

            img {
                width: 60px;
                margin-right: 10px;
                margin-bottom: 10px;
                cursor: pointer;
            }
            .active {
                // border: 2px solid red;
                box-shadow: 0 0 5px blue;
                box-sizing: border-box;
            }
        }
    }
    .diyimg-right {
        right: 131px;
    }
}
/deep/.validate {
    &::before {
        content: "*";
        display: inline-block;
        margin-right: 4px;
        line-height: 1;
        font-family: SimSun;
        font-size: 14px;
        color: #ed4014;
    }
}
.cropper-content {
    .cropper {
        width: 580px;
        height: 428px;
    }
}
.ivu-form-inline .ivu-form-item{
    display: block;
}
.info{
    display:flex !important;
}
.btn-div{
    display: flex;
    justify-content: center;
    position: absolute;
    width: 100%;
    bottom: 0px;
    height: 100px;
    border-top: 1px solid #ccc;
    box-shadow: 0 0 3px #bbb;
    background: #fff;
}
</style>
